/**
 * Un `input[type=number]` enfocado consume la rueda para cambiar el valor.
 * Soltar el foco antes de la acción por defecto deja que el mismo gesto siga
 * desplazando el modal, sin cancelar el evento ni romper teclado, escritura
 * manual, min o max.
 */
export function releaseNumberInputOnWheel(event: { currentTarget: { blur: () => void } }): void {
  event.currentTarget.blur();
}
